const FACE_TEC_ID_PREFIX = 'DOM_FT_';
const RESET_BODY_STYLE_PROPERTIES = ['overflow', 'position', 'width', 'height', 'touch-action', 'background-color'];
const CLEANUP_RETRY_DELAYS_MS = [0, 120, 350, 800];

const clearInlineStyles = (element: HTMLElement, properties: string[]) => {
  properties.forEach((property) => element.style.removeProperty(property));
};

export const removeUnicoSdkDomArtifacts = (containerId = 'box-camera') => {
  const container = document.getElementById(containerId);

  const artifacts = Array.from(document.querySelectorAll<HTMLElement>(`[id^="${FACE_TEC_ID_PREFIX}"]`));
  artifacts.forEach((node) => node.remove());

  if (container) {
    const containerArtifacts = Array.from(container.querySelectorAll<HTMLElement>(`[id^="${FACE_TEC_ID_PREFIX}"]`));
    containerArtifacts.forEach((node) => node.remove());
  }

  clearInlineStyles(document.body, RESET_BODY_STYLE_PROPERTIES);
  clearInlineStyles(document.documentElement, ['overflow', 'height']);
};

export const scheduleUnicoSdkDomCleanup = (containerId = 'box-camera') => {
  const timerIds = CLEANUP_RETRY_DELAYS_MS.map((delay) =>
    window.setTimeout(() => {
      removeUnicoSdkDomArtifacts(containerId);
    }, delay),
  );

  return () => {
    timerIds.forEach((id) => window.clearTimeout(id));
  };
};
